module.exports = __webpack_public_path__ + "img/svti-logo.ab942ee2.svg";